const hasDevOverrideForFunction = localStorage.getItem('devmode') === 'true';

export function getURLFromFunctionName(name: string): string {
  return hasDevOverrideForFunction
    ? `http://127.0.0.1:5010/big-quanta-375810/us-central1/${name}`
    : `https://us-central1-big-quanta-375810.cloudfunctions.net/${name}`;
}

export function isPastConversationDate(conversationDate: string): boolean {
  const conversationDateTime = new Date(conversationDate);
  const currentDateTime = new Date();
  return conversationDateTime < currentDateTime;
}

export function getPendingNumberOfDays(conversationDate: string): number {
  const diffDays = Math.ceil(
    (new Date(conversationDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
  );

  return diffDays;
}

export function getPendingNumberOfDaysString(conversationDate: string): string {
  const diffDays = Math.ceil(
    (new Date(conversationDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffDays > 1) {
    return `${diffDays} days`;
  }

  return `${diffDays} day`;
}

// Add N days to the current date and return as Data Month, Year Format
// eg: 2023-10-25 after adding 5 days will be 10 Oct, 2023
export function addNDaysToDate(date: string, n: number): string {
  const currentDate = new Date(date);
  const newDate = new Date(currentDate.setDate(currentDate.getDate() + n));
  return `${newDate.getDate()} ${newDate.toLocaleString('default', { month: 'short' })}, ${newDate.getFullYear()}`;
}
